module.exports = __webpack_public_path__ + "static/media/managestaff.73c946f8.svg";